module.exports = __webpack_public_path__ + "static/media/cooperation-hero.015a22c6.jpg";